import React from 'react';
import { MAX_TANK_VOLUME, ALERT_THRESHOLD } from '../hooks/useFirebaseData';

export default function InventoryTracker({ inventory, onRestock }) {
  const kioskEntries = Object.entries(inventory);

  if (kioskEntries.length === 0) {
    return (
      <div className="section">
        <h2 className="section-title">
          <span className="section-title-icon">📍</span>
          Fleet Inventory Status
        </h2>
        <div className="empty-state">
          <span className="empty-state-icon">🧃</span>
          <p>No kiosks reporting inventory data yet.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="section">
      <h2 className="section-title">
        <span className="section-title-icon">📍</span>
        Fleet Inventory Status
      </h2>

      <div className="inventory-grid">
        {kioskEntries.map(([kioskId, juices]) => {
          const juiceEntries = Object.entries(juices);
          const totalCapacity = juiceEntries.length * MAX_TANK_VOLUME;
          const totalFilled = juiceEntries.reduce((sum, [, amt]) => sum + amt, 0);
          const overallPercent = Math.round((totalFilled / totalCapacity) * 100);
          const hasAlert = juiceEntries.some(([, amt]) => amt <= ALERT_THRESHOLD);

          return (
            <div key={kioskId} className={`inventory-card ${hasAlert ? 'inventory-card--alert' : ''}`}>
              <div className="inventory-card-header">
                <div className="inventory-card-title">
                  <span className={`inventory-status-dot ${hasAlert ? 'inventory-status-dot--alert' : ''}`} />
                  <h3>{kioskId}</h3>
                </div>
                <div className={`inventory-badge ${hasAlert ? 'inventory-badge--alert' : ''}`}>
                  {overallPercent}% Full
                </div>
              </div>

              <div className="inventory-juice-list">
                {juiceEntries.map(([juiceId, amount]) => {
                  const cleanName = juiceId.replace('juice_', '').replace(/_/g, ' ').toUpperCase();
                  const percentage = Math.min((amount / MAX_TANK_VOLUME) * 100, 100);
                  const isLow = amount <= ALERT_THRESHOLD;

                  return (
                    <div key={juiceId} className="inventory-juice-item">
                      <div className="inventory-juice-row">
                        <span className="inventory-juice-name">{cleanName}</span>
                        <div className="inventory-juice-actions">
                          <span className={`inventory-juice-amount ${isLow ? 'inventory-juice-amount--low' : ''}`}>
                            {amount.toLocaleString()} ml
                            {isLow && <span className="inventory-alert-badge">⚠️ LOW</span>}
                          </span>
                          <button
                            className="inventory-restock-btn"
                            onClick={() => onRestock(kioskId, juiceId, cleanName)}
                            title={`Refill ${cleanName} to ${MAX_TANK_VOLUME}ml`}
                          >
                            🔄 Refill
                          </button>
                        </div>
                      </div>

                      {/* Progress Bar */}
                      <div className="inventory-bar-track">
                        <div
                          className={`inventory-bar-fill ${isLow ? 'inventory-bar-fill--low' : ''}`}
                          style={{ width: `${percentage}%` }}
                        />
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
